function checkInterceptor(app, error) {
  if(app.showLoading) {
    app.showLoading = false
    app.textLoading = null
  }
  app.silentLoading = false

  let token = localStorage.getItem('token');
  console.warn('Response Error');
  if (error && error.response.data.message && token) {
    let tokenError = false
    _.forEach(_.words(error.response.data.message), (word) => {
      if(_.toLower(word) == 'token' || _.toLower(word) == 'client') {
          tokenError = true
      }
    })

    if(tokenError){
        error.response.data.message += '<br>Por favor, tente novamente'
    }
  }
}

export default function (resource) {
  resource.interceptors.request.use(function (config) {
    if(!app.showLoading) {
      app.showLoading = app.silentLoading ? false : true
      app.textLoading = null
    }

    let url = config.url
    if(_.size(_.split(url,'?')) > 1){
      config.url += "&NotRedirect=true"
    }
    else{
      config.url += "?NotRedirect=true"
    }

    let token = localStorage.getItem('token')
    config.headers["Authorization"] = token ? 'Bearer ' + token : ''
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    // config.headers["NotRedirect"] = true
    return config;
  }, function (error) {
    console.warn('REQUEST')
    checkInterceptor(app, error);
    return Promise.reject(error);
  });

  resource.interceptors.response.use(function (response) {
    if(app.showLoading) {
      app.showLoading = false
      app.textLoading = null
    }
    if( app.alert) {
      app.alert.texto = null
      app.alert.tipo = 'primary'
      app.alert.funcao = null
      app.alert.textBotao = null
      app.silentLoading = false
    }
    return response;
  }, function (error) {
    if(error.response && error.response.status == '401'){
      app.setAlert('Você deve estar autenticado para acessar esta área. Faça o login para continuar.','danger')
      app.$router.push({name: 'autenticacao'})
    }
    console.warn('RESPONSE')
    checkInterceptor(app, error)
    return Promise.reject(error)
  });
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/interceptor.js
// module id = null
// module chunks = 